module.exports = __webpack_public_path__ + "assets/no-image.1bb6acd6.svg";